import React from "react";
import { Box, Button, Tooltip, Typography } from "@mui/material";

const CreditMeter = ({
  balance = 0,
  onTopUp,
  showTopUp = true,
  lowThreshold = 5,
  isUnlimited = false,
  // A migrated business's plan_entitlements can read as unlimited (a migration-time
  // stopgap, not a real Enterprise plan) - when isMigrated is true, show its actual
  // plan name (from subscription-logs) instead of "Unlimited Credits", and never
  // offer self-serve top up (their plan isn't Custom either).
  isMigrated = false,
  planName = null,
}) => {
  const isEmpty = !isUnlimited && balance === 0;
  const isLow = !isUnlimited && balance > 0 && balance <= lowThreshold;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "3px",
        borderRadius: "999px",
        maxWidth: "100%",
        boxSizing: "border-box",
        flexShrink: 1,

        "@media (max-width: 768px)": {
          gap: "4px",
          padding: "3px",
        },

        "@media (max-width: 480px)": {
          gap: "3px",
          padding: "2px",
        },

        border: isEmpty
          ? "1px solid #F3C8C8"
          : isLow
            ? "1px solid #F4D88A"
            : "1px solid #D8CCFF",

        backgroundColor: isEmpty
          ? "#FFF7F7"
          : isLow
            ? "#FFFBF0"
            : "#F8F5FF",
      }}
    >
      {/* Balance */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "7px",
          padding: "6px 10px",
          minWidth: 0,
          flexShrink: 1,

          "@media (max-width: 768px)": {
            gap: "5px",
            padding: "5px 7px",
          },

          "@media (max-width: 480px)": {
            gap: "4px",
            padding: "4px 6px",
          },
        }}
      >
        {/* Credit icon */}
        {/* <Box
          sx={{
            width: { xs: "22px", sm: "24px" },
            height: { xs: "22px", sm: "24px" },
            borderRadius: "50%",
            backgroundColor: isEmpty
              ? "#D71920"
              : isLow
                ? "#F5A000"
                : "#7651FF",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: { xs: "12px", sm: "13px" },
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          ₹
        </Box> */}

        <Typography
          sx={{
            fontSize: { xs: "12px", sm: "14px" },
            fontWeight: 500,
            color: isEmpty
              ? "#C51E24"
              : isLow
                ? "#8B6200"
                : "#29243D",
            whiteSpace: "nowrap",
          }}
        >
          {isMigrated ? (planName || "Migrated Plan") : isUnlimited ? "Unlimited Credits" : `${balance} Credits`}
        </Typography>

        {/* Low balance indicator */}
        {/* {isLow && ( */}
        <Box
          sx={{
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            backgroundColor: "#F5A000",
          }}
        />
        {/* )} */}
      </Box>

      {/* Top Up - disabled (not hidden) for plans that don't self-serve top up,
          e.g. Enterprise, whose credits are managed by their account manager.
          Migrated businesses never self-serve top up either. */}
      {!isUnlimited && !isMigrated && (
        <Tooltip title={showTopUp ? "" : "Your plan's credits are managed by your account manager"}>
          <span>
            <Button
              onClick={onTopUp}
              // disabled={!showTopUp}
              sx={{
                minWidth: "auto",
                width: "auto",
                height: { xs: "32px", sm: "34px" },
                padding: { xs: "0 9px", sm: "0 14px" },
                borderRadius: "999px",
                backgroundColor: "#6846F5",
                color: "#fff",
                fontSize: { xs: "12px", sm: "13px" },
                fontWeight: 600,
                textTransform: "none",
                whiteSpace: "nowrap",
                flexShrink: 0,
                boxShadow: "none",

                "&:hover": {
                  backgroundColor: "#5938E5",
                  boxShadow: "none",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#E4E1F5",
                  color: "#9B96B8",
                },
              }}
            >
              + Top up
            </Button>
          </span>
        </Tooltip>
      )}

    </Box>
  );
};

export default CreditMeter;